export const Clock = {
    methods: {
        //TODO：查询全部部门（树形）带员工
        async getEmployeeTree() {
            let res = await this.$http.get('/tenant/common/employeeTree')
            return res;
        },
        //查询所有打卡记录
        async getClockList(params) {
            let {time,employeeNos,pageNum,pageSize} = params
            let res = await this.$http.get("/tenant/clock/list",{
                time:time??null,
                employeeNos:employeeNos??null,
                pageNum:pageNum??null,
                pageSize:pageSize??null``
            });
            return res;
        },
        //修改打卡记录
        async upClock(obj) {
            let res = await this.$http.put("/tenant/clock/edit", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
        },
        //删除打卡记录
        async delClock(obj) {
            let res = await this.$http.delete(`/tenant/clock/delete/${obj.id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
        },
        //查询打卡提示语
        async getClockTip(params) {
            let res = await this.$http.get("/tenant/clock/clockTip",{

            });
            return res;
        },
        //修改或保存提示语
        async editClockTip(obj) {
            let res = await this.$http.post("/tenant/clock/editClockTip", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
        },
        //获取打卡类型
        async getClockType() {
            let res = await this.$http.get("/tenant/clock/getClockType");
            return res;
        },
    }
};
